export default {
    "colors": {
        "noiseAdc": "#A91D45",
        "noiseDriver": "#049dbb",
        "noiseSource": "#2eca5d",
        "noiseSystem": "#333333",
        "noiseSignal": "#808080"
    },
}